module.exports = __webpack_public_path__ + "img/cartaoDescontos.f240c9ff.png";